import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { TimelineItemInterface } from '~/component/timeline/interfaces/item.interface';
import { TitleService } from '~/core/services/title/title.service';
import { OrganizerSharedPageAbstract } from '~/organizer/shared/components/pages/abstract/page.abstract';

import { OrganizerSharedPageStepsPageInterface } from './interfaces/page.interface';
import { OrganizerSharedPageStepsTimelineConfigInterface } from './interfaces/timeline.config.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-organizer-shared-page-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
})
export class OrganizerSharedPageStepsComponent extends OrganizerSharedPageAbstract<OrganizerSharedPageStepsPageInterface> {
  protected readonly pageCssClass = 'organizer-shared-page-steps';
  private timelineConfig: OrganizerSharedPageStepsTimelineConfigInterface[] =
    [];
  public imageSource: string;
  public stepsSubTitleKey: string;
  public stepsTitleKey: string;

  constructor(
    private readonly translateService: TranslateService,
    protected readonly activatedRoute: ActivatedRoute,
    protected readonly location: Location,
    protected readonly titleService: TitleService
  ) {
    super(activatedRoute, location, titleService);
  }

  public get steps(): TimelineItemInterface[] {
    return this.timelineConfig.map(
      (config: OrganizerSharedPageStepsTimelineConfigInterface) => ({
        content: this.translateService.instant(config.contentKey),
        iconType: config.iconType,
      })
    );
  }

  protected getPagesConfig(): {
    [key: string]: OrganizerSharedPageStepsPageInterface;
  } {
    return {
      'organizer.activity-creation.steps': {
        stepsTitleKey: 'activity_creation.steps.timeline.title',
        stepsSubTitleKey: 'activity_creation.steps.timeline.sub-title',
        imageSource: 'assets/organizer/activity-creation/steps/background.jpg',
        layoutCssClass: 'organizer-activity-creation-page-steps',
        pageTitleKey: 'seo.organizer.activity_creation.steps.title',
        timelineConfig: [
          { contentKey: 'activity_creation.steps.timeline.1.content' },
          { contentKey: 'activity_creation.steps.timeline.2.content' },
          { contentKey: 'activity_creation.steps.timeline.3.content' },
          {
            contentKey: 'activity_creation.steps.timeline.4.content',
            iconType: VtmnPlayIconTypeEnum.ThumbUp,
          },
        ],
      },
    };
  }

  public setPageValues(
    pageConfig: OrganizerSharedPageStepsPageInterface
  ): void {
    this.pageTitleKey = pageConfig.pageTitleKey;
    this.stepsTitleKey = pageConfig.stepsTitleKey;
    this.stepsSubTitleKey = pageConfig.stepsSubTitleKey;
    this.timelineConfig = pageConfig.timelineConfig;
    this.imageSource = pageConfig.imageSource;
  }
}
